module.exports = __webpack_public_path__ + "img/home_part3_bg.3828c985.png";